import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";

export default function Sidebar({ isCollapsed, onToggle, isMobileOpen, onMobileClose }) {
  const location = useLocation();

  const menuItems = [
    {
      name: "Trang chủ",
      icon: "fas fa-home",
      path: "/",
      badge: null
    },
    {
      name: "Sổ thuê acc",
      icon: "fas fa-book",
      path: "/bookings",
      badge: null
    },
    {
      name: "Quản lý bài viết",
      icon: "fas fa-blog",
      path: "/blogs",
      badge: null
    },
    {
      name: "Quảng cáo",
      icon: "fas fa-ad",
      path: "/ads",
      badge: null
    },
    {
      name: "Khối nội dung nóng",
      icon: "fas fa-fire",
      path: "/hot-sections",
      badge: null
    },
    {
      name: "Cài đặt",
      icon: "fas fa-cog",
      path: "/settings",
      badge: null
    }
  ];

  const toggleSidebar = () => {
    onToggle(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-logo">
        <div className="logo-icon">CF</div>
        {!isCollapsed && <span className="logo-text">HoangLeCF</span>}
      </div>

      <div className="sidebar-menu">
        {!isCollapsed && <div className="menu-header">MENU CHÍNH</div>}
        <ul className="menu-list">
          {menuItems.map((item, index) => (
            <li key={index} className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}>
              <Link to={item.path} className="menu-link" title={isCollapsed ? item.name : ''}>
                <i className={`menu-icon ${item.icon}`}></i>
                {!isCollapsed && <span className="menu-text">{item.name}</span>}
                {!isCollapsed && item.badge && (
                  <span className={`menu-badge ${item.badge === 'NEW' ? 'badge-new' : 'badge-count'}`}>
                    {item.badge}
                  </span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <button className="sidebar-toggle" onClick={toggleSidebar} title={isCollapsed ? 'Mở rộng' : 'Thu nhỏ'}>
        <i className={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
      </button>
    </div>
  );
}
